<template>
  <div id="app">
    <Head></Head>
      <router-view />
    <Foot></Foot>
  </div>
</template>

<script>
import Head from '@/components/Head'
import Foot from '@/components/Foot'
export default {
  name: 'App',
  data(){
    return {
    }
  },
  components: {
    Head,
    Foot
  },
  methods: {
  },
  updated(){
  },
  created () {
    //语言 优先级：sessionStorage > zh-CN
    var language = sessionStorage.getItem('language');
    if (language) {
      this.$i18n.locale = language
    } else {
      this.$i18n.locale = 'zh-CN'
      sessionStorage.setItem('language', 'zh-CN')
      sessionStorage.setItem('lang', 1)
    }
  },
  mounted(){
    //顶部导航悬浮
    window.onscroll = function(){
      let menu = document.getElementById('menu')
      let s = document.body.scrollTop || document.documentElement.scrollTop
      if (s > 34) {
        menu.style.position = 'fixed';
        menu.style.top = 0;
        menu.style.zIndex = 999;
      } else {
        menu.style.position = 'static'
      }
    };


    //rem 
    (function(doc,win){
      var docEl = doc.documentElement,resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
      recalc = function(){
        var clientWidth = docEl.clientWidth;
        if(!clientWidth) return;
        if(clientWidth>=750){
          docEl.style.fontSize = '200px';
        }
        else{
          docEl.style.fontSize = 200 * (clientWidth / 750) + 'px';
        }
      };
      if (!doc.addEventListener) return;
        win.addEventListener(resizeEvt, recalc, false);
        doc.addEventListener('DOMContentLoaded', recalc, false);
    })(document,window);

    
  }
}
</script>

<style lang="scss">
@import url(./style/reset.scss);
@import './style/media.scss';

#app {
  // background: #f6f6f6;
  background: #f9f9f9;
}

/*浏览器滚动条样式*/

::-webkit-scrollbar-track {
  // -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3); // background-color: #F5F5F5;
  opacity: 0; // background-color: hsla(220, 4%, 58%, .3);
  border-radius: 5px;
  transition: opacity .12s ease-out;
}

::-webkit-scrollbar {
  width: 5px;
  height: 10px; // background-color: #F5F5F5;
  z-index: 999;
}

::-webkit-scrollbar-thumb {
  border-radius: 5px;
  width: 10px;
  background-color: hsla(220, 4%, 58%, .2);
  transition: background-color .3s; // border-radius: 10px;
  // background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0.44, rgb(122, 153, 217)), color-stop(0.72, rgb(73, 125, 189)), color-stop(0.86, rgb(28, 58, 148)));
}

//font
@font-face {
  font-family: 'dkfont';
  src: url('./fonts/iconfont.eot');
  src: url('./fonts/iconfont.eot?#iefix') format('embedded-opentype'),
  url('./fonts/iconfont.woff') format('woff'),
  url('./fonts/iconfont.ttf') format('truetype'),
  url('./fonts/iconfont.svg#iconfont') format('svg');
}

.dk {
  font-family:"dkfont" !important;
  font-size:16px;
  font-style:normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}

</style>



// WEBPACK FOOTER //
// src/App.vue